const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassportForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.748,
    height: 26.098,
    viewBox: "0 0 21.748 26.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -1.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1246",
    width: 14.788,
    height: 2.61,
    rx: 1.305,
    transform: "translate(9.48 15.047)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1247",
    width: 13.048,
    height: 2.61,
    rx: 1.305,
    transform: "translate(9.48 20.267)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1811"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2223",
    d: "M34.94 8.958h4.61a.593.593 0 0 0 .609-.609.544.544 0 0 0-.174-.435l-5.741-5.741A.544.544 0 0 0 33.809 2a.593.593 0 0 0-.609.609v4.61a1.745 1.745 0 0 0 1.74 1.74z",
    transform: "translate(-12.412)",
    style: {
      fill: "#aadbb0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2224",
    d: "M26.877 11.569h-6.089a2.615 2.615 0 0 1-2.61-2.61V2.87a.87.87 0 0 0-.87-.87H8.61A2.615 2.615 0 0 0 6 4.61v20.877A2.615 2.615 0 0 0 8.61 28.1h16.528a2.615 2.615 0 0 0 2.61-2.61V12.439a.87.87 0 0 0-.871-.87z",
    transform: "translate(0 -.001)",
    style: {
      fill: "#aadbb0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1813"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1874",
    d: "M22.8 12.3H7.929A1.057 1.057 0 0 1 7 11.15 1.057 1.057 0 0 1 7.929 10H22.8a1.057 1.057 0 0 1 .929 1.15 1.057 1.057 0 0 1-.929 1.15z",
    transform: "translate(1.539 5.197)",
    style: {
      fill: "#dcefdf"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1814"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1875",
    d: "M17.348 16.3H8.15a1.15 1.15 0 0 1 0-2.3h9.2a1.15 1.15 0 0 1 0 2.3z",
    transform: "translate(1.539 5.797)",
    style: {
      fill: "#dcefdf"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1815"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1875",
    d: "M14.911 16.3H7.879A1.042 1.042 0 0 1 7 15.15 1.042 1.042 0 0 1 7.879 14h7.032a1.042 1.042 0 0 1 .879 1.15 1.042 1.042 0 0 1-.879 1.15z",
    transform: "translate(1.539 -3.402)",
    style: {
      fill: "#dcefdf"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportForm);
export default __webpack_public_path__ + "static/media/passportForm.6add06dd2a8a0a4fe1cec1f03b67d53a.svg";
export { ForwardRef as ReactComponent };